const sx = {
  form: {
    maxWidth: 320,
    my: 4.25,
    mx: 'auto',
    textAlign: 'left',
  },
};

export default sx;
